import { render } from "./loadprogress.vue?vue&type=template&id=23c6944e&scoped=true"
import script from "./loadprogress.vue?vue&type=script&lang=js"
export * from "./loadprogress.vue?vue&type=script&lang=js"

import "./loadprogress.vue?vue&type=style&index=0&id=23c6944e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c6944e"]])

export default __exports__